// 检测是否为移动设备
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // 匹配常见的移动端标识
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
};

// 强制重定向到移动版或桌面版
export const handleDeviceRedirect = (currentPath: string) => {
  const isMobile = isMobileDevice();
  const isMobilePath = currentPath.startsWith('/m');
  // 不在这里强制重定向认证页或管理页，允许在移动设备上访问 /login /register /admin/*
  const allowPathsOnMobile = ['/login', '/register'];
  if (allowPathsOnMobile.includes(currentPath)) return null;

  // 如果是手机设备但不在移动路径 -> 去 /m/home
  if (isMobile && !isMobilePath) {
    return '/m/home';
  }
  
  // 如果是桌面设备但完全在移动路径 -> 回桌面首页
  // 注意：允许桌面端调试移动页，所以这个可以根据需求选做，暂时不强制切回，方便你开发调试
  // if (!isMobile && isMobilePath) {
  //   return '/home';
  // }
  
  return null;
};
